// src/pages/AiGame404.jsx

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Styles.css";

const randomLatency = () =>
  20 + Math.floor(Math.random() * 120);

export default function AiGame404() {
  const navigate = useNavigate();

  const [logs, setLogs] = useState([]);
  const [attempts, setAttempts] = useState(0);
  const [processing, setProcessing] = useState(false);

  const maxAttempts = 3;

  useEffect(() => {
    setLogs([
      {
        id: 1,
        type: "system",
        text: "404 ERROR — Requested route could not be resolved."
      },
      {
        id: 2,
        type: "ai",
        text: "Neomonks AI Assistant initialized."
      },
      {
        id: 3,
        type: "ai",
        text: "Attempting intelligent route recovery..."
      }
    ]);
  }, []);

  const addLog = (type, text) => {
    setLogs((prev) => [
      ...prev,
      {
        id: prev.length + 1,
        type,
        text
      }
    ]);
  };

  const handleRecovery = () => {
    if (processing || attempts >= maxAttempts) return;

    const currentAttempt = attempts + 1;

    setProcessing(true);

    addLog(
      "user",
      `Recovery attempt ${currentAttempt} started.`
    );

    setTimeout(() => {
      addLog(
        "ai",
        "Analyzing navigation history and endpoint registry..."
      );
    }, 400);

    setTimeout(() => {
      addLog(
        "system",
        `Network latency detected: ${randomLatency()}ms`
      );
    }, 900);

    setTimeout(() => {
      if (currentAttempt === 1) {
        addLog(
          "ai",
          "Partial route signature detected, but target endpoint is unavailable."
        );
      }

      if (currentAttempt === 2) {
        addLog(
          "ai",
          "No active deployment found for this route. Verifying archived references..."
        );
      }

      if (currentAttempt === 3) {
        addLog(
          "ai",
          "Recovery unsuccessful. Redirect recommended to a stable route."
        );

        addLog(
          "system",
          "Suggestion: Return to homepage or verify the requested URL."
        );
      }

      setAttempts(currentAttempt);
      setProcessing(false);
    }, 1800);
  };

  return (
    <div className="neo404-wrapper">

      {/* Background glow */}
      <div className="neo404-glow"></div>

      <div className="neo404-card">

        <div className="neo404-badge">
          ERROR 404
        </div>

        <h1 className="neo404-title">
          Route Not Found
        </h1>

        <p className="neo404-subtitle">
          The page you’re looking for may have been moved,
          removed, or is temporarily unavailable.
        </p>

        {/* CONSOLE */}
        <div className="neo404-console">

          <div className="neo404-console-top">
            <span></span>
            <span></span>
            <span></span>

            <p>Neomonks Diagnostic Console</p>
          </div>

          <div className="neo404-console-body">

            {logs.map((log) => (
              <div
                key={log.id}
                className={`neo404-log ${log.type}`}
              >
                <label>
                  {log.type === "ai"
                    ? "AI"
                    : log.type === "system"
                    ? "SYSTEM"
                    : "USER"}
                </label>

                <span>{log.text}</span>
              </div>
            ))}

            {processing && (
              <div className="neo404-log ai">
                <label>AI</label>

                <span className="typing">
                  Processing<span>.</span><span>.</span><span>.</span>
                </span>
              </div>
            )}

          </div>

        </div>

        {/* ACTIONS */}
        <div className="neo404-actions">

          <button
            className="neo404-btn primary"
            onClick={handleRecovery}
            disabled={processing || attempts >= maxAttempts}
          >
            {processing
              ? "Analyzing..."
              : attempts >= maxAttempts
              ? "Recovery Complete"
              : "Run Diagnostics"}
          </button>

          <button
            className="neo404-btn secondary"
            onClick={() => navigate("/")}
          >
            Return Home
          </button>

        </div>

      </div>

    </div>
  );
}